// extracted by mini-css-extract-plugin
export default {"tabs":"OrganisationDetails_tabs__C1K7z","tabLink":"OrganisationDetails_tabLink__PmJx6","tag":"OrganisationDetails_tag__Vrf9L"};